const ELEVATION_PREFIX = "md-elevation-";
const DEFAULT_ELEVATION = "0";
function getParent(component) {
  if (component) {
    const getParentElevation = parent => {
      if (parent) {
        const parentProperty = parent.mdElevation;
        if (parentProperty) return parentProperty;else return getParentElevation(parent.$parent);
      }
      return DEFAULT_ELEVATION;
    };
    return getParentElevation(component.$parent);
  }
  return undefined;
}
var MdElevation = {
  props: {
    mdElevation: {
      type: String,
      default: ""
    }
  },
  computed: {
    $mdActiveElevation() {
      const parentElevation = getParent(this);
      const selfElevation = `mde-${this.mdElevation || parentElevation}`;
      return `${ELEVATION_PREFIX}${parentElevation} ${selfElevation}`;
    }
  }
};

export { MdElevation as M };
